'use client'
import {
  commonWhere
} from "./chunk-VCKNEC77.mjs";
import {
  LOCATION_QUERY
} from "./chunk-KJDK3CSR.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-HLVUCALY.mjs";
import {
  CATEGORY_QUERY
} from "./chunk-ZZ3DUO5U.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  CURRENCY_QUERY
} from "./chunk-PXTWVUHC.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/events/listing.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getEventListing($lang: String, $limit: Int, $skip: Int, $where: EventFilter, $order: [EventOrder]) {
  eventCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      id
      title
      slug
      image11{${IMAGE_QUERY}}
      price
      currency{${CURRENCY_QUERY}}
      schedule{${SCHEDULE_QUERY}}
      location{${LOCATION_QUERY}}
      category{${CATEGORY_QUERY}}
      order
      featured
      tier
      sellersCollection(limit: 3){
        items{id title}
      }
    }
  }
}
`;
var getEventListing = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: ["tier_ASC", "order_ASC"]
    }, props), {
      where: __spreadValues(__spreadValues({}, commonWhere), props.where)
    }));
    return res.eventCollection;
  } catch (error) {
    throw new Exception({ error, name: "getEventListingException" });
  }
});
var useGetEventsList = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getEventsList", props],
    queryFn: () => getEventListing(props)
  }));
};

export {
  getEventListing,
  useGetEventsList
};
//# sourceMappingURL=chunk-TW33R6V4.mjs.map